module.exports = __webpack_public_path__ + "static/cee-5bd99422e510dbe47e65acea3cd0d9af.png";